<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-carousel height="auto" cycle hide-delimiters>
          <v-carousel-item v-for="(image, index) in carousel" :key="index">
            <v-img :src="image" />
          </v-carousel-item>
        </v-carousel>
        
   

        <!-- esto es sobre las noticias -->
        <v-row justify="center">
          <v-col cols="12">
            <ListHorizontal />
          </v-col>
        </v-row>
           

 
      

    


        <h1 class="text-uppercase">Entretenimiento</h1>
        <span class="title">El mejor contenido a tu alcance</span>
        <div
          style="width: 6%; height: 3px;margin: 10px auto;background:#0D47A1;border-bottom: 1px solid black;"
        />
        <v-flex xs12 pa-2>
          <v-layout align-center justify-center row wrap fill-height>
            <v-flex
              v-for="(category, index) in categories"
              :key="index"
              pa-2
              xs12
              sm4
            >
              <v-card>
                <v-img :src="category.imageUrl" height="200px">
                  <v-container fill-height pa-2>
                    <v-layout align-start justify-start>
                      <span class="headline white--text">
                        {{ category.title }}
                      </span>
                    </v-layout>
                    <v-layout align-end justify-end>
                      <v-btn :to="category.path" icon dark>
                        <v-icon size="40">keyboard_arrow_right</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-container>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-col>
    </v-row>
           <v-img 
          class="white--text"
          height="auto"
          src="https://firebasestorage.googleapis.com/v0/b/telemontv-web.appspot.com/o/ssss.png?alt=media&token=706df52b-efad-4419-aa08-1905bad0c6c2"
        >
        
        </v-img>
    <v-row align="center" justify="space-around">
      <v-col cols="12" md="6" sm="6" lg="6">
        <p class="titleD">Descarga la App</p>
        <p class="titleTelemo">Telemontv</p>
        <hr />
        <p class="textDescription mt-4 ml-2">
          Llévanos contigo a donde quiera que vayas,
          <span class="subtitle">realiza tus consultas</span> en otro de
          nuestros canales digitales.
        </p>
        <v-btn
          href="https://play.google.com/store/apps/details?id=com.el12n.telemon_flutter&hl=es&gl=US"
          x-large
          height="80"
          width="240"
          color="white"
          class="ml-2 mt-6"
        >
          <img height="80" src="../../assets/btnGoogle.jpeg" />
        </v-btn>

        <v-btn
          href="https://apps.apple.com/do/app/telemon-tv/id1471660847"
          x-large
          height="80"
          width="240"
          color="white"
          class="ml-6 mt-6"
        >
          <img height="80" src="../../assets/btnIos.jpeg" />
        </v-btn>
      </v-col>
      <v-col cols="12" md="3" sm="3" lg="3">
        <img height="500" src="../../assets/app.jpeg" />
      </v-col>
    </v-row>

  <v-flex xs12 pa-2 class="text-center">
      <v-card color="primary" height="300">
        <v-container fill-height pa-2>
          <v-layout align-center justify-center row wrap>
            <v-flex xs12>
              <p
                class="display-1 font-weight-regular white--text text-uppercase mb-0"
              >
                Telemon tv
              </p>
              
              <p class="subheading white--text mt-0">El cable del pueblo</p>
              <v-btn outlined dark to="/about">Más información</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <v-flex xs12 pa-2 class="text-center">
      <v-card class="pa-5" color="primary">
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text>
              <p class="display-1 font-weight-bold white--text">
                Explora nuestras opciones
              </p>
              <p class="subheading white--text">Internet y Cable</p>
            </v-card-text>
          </v-flex>
          <v-layout justify-center row wrap class="text-center">
            <v-flex
              v-for="(service, index) in services"
              :key="index"
              class="mb-3 px-1"
              xs12
              md3
            >
              <v-card class="py-5" color="blue darken-2" min-height="400" text>
                <v-card-title>
                  <v-layout align-center justify-center>
                    <v-icon size="80" color="white">{{ service.icon }}</v-icon>
                  </v-layout>
                </v-card-title>
                <v-card-text>
                  <p class="title font-weight-bold white--text">
                    {{ service.title }}
                  </p>
                  <p class="white--text">{{ service.description }}</p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-btn outlined dark to="/packages">
              <span>Planes disponibles</span>
              <v-icon size="15" right dark>arrow_forward_ios</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12 md12 pa-2>
      <subscribe-container></subscribe-container>
    </v-flex>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { formatDate } from "../../filters";
import SubscribeContainer from "../../components/shared/Subscribe-Container";
import ListHorizontal from "./ListHorizontal";

export default {
  filters: {
    date(value) {
      return formatDate(value);
    },
  },
  components: {
    SubscribeContainer,
    ListHorizontal,
  },
  data: () => ({
    services: [
      {
        title: "Entretenimeinto",
        description:
          "El mejor entretenimiento del mercado solicita uno de nuestros planes y compruebalo.",
        icon: "tv",
      },
      {
        title: "Televisión HD",
        description:
          "Canales HD para que disfrutes de tus programas favoritos con la calidad que mereces.",
        icon: "hd",
      },
      {
        title: "Internet",
        description:
          "Nuestro servicio de internet a la mayor velocidad sin contratiempos.",
        icon: "wifi",
      },
      {
        title: "Soporte 24/7",
        description:
          "Para cualquier duda o inconveniente estamos disponibles para servirte.",
        icon: "phone",
      },
    ],
  }),

  mounted() {
    this.loadCarousel();
    this.loadCategories();
    this.linstingUpdateRequestClaim();
    this.linstingUpdateRequestPACKAGE();
  },
  computed: mapState({
    categories: (state) => state.home.categories,
    carousel: (state) => state.home.carousel.reverse(),
  }),
  methods: {
    ...mapActions([
      "loadCategories",
      "loadCarousel",
      "linstingUpdateRequestClaim",
      "linstingUpdateRequestPACKAGE",
    ]),
  },
};
</script>


<style scoped>
.titleTelemo {
  color: #003068;
  font-size: 3rem;
}
.titleD {
  color: black;
  font-size: 4rem;
}
.textDescription {
  color: black;
  font-size: 1.2rem;
}
.textGoogleplay {
  color: white;
}
.subtitle {
  color: #003068;
  font-weight: bold;
}
hr {
  width: 210px;
  margin-left: 8px;
  border: 1px solid #efa73b;

  height: 7px;
  background-color: #efa73b;

}
.circular {
  width: 90px;
  height: 90px;
}
</style>
